export default __webpack_public_path__ + "static/media/banner1.917ec9a7.jpg";